import axios from 'axios';
import Vue from 'vue';
import { Notification, MessageBox } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
import errorCode from '@/utils/errorCode';
import { tansParams } from '@/utils/ruoyi';
import cache from '@/utils/cache';
// import { saveAs } from 'file-saver';
import { i18n } from '@/i18n/i18n'

const languageMap = {
    'zh': 'zh-CN',
    'en': 'en-US'
}

// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: '',
    // 超时
    timeout: 20000,
});

// request拦截器
service.interceptors.request.use(
    (config) => {
        const accept_language = sessionStorage.getItem('accept_language');
        config.headers.language = accept_language ? languageMap[accept_language] : 'en-US';
        // 是否需要设置 token
        const isToken = (config.headers || {}).isToken === false;
        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
        if (getToken() && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        // get请求映射params参数
        if (config.method === 'get' && config.params) {
            let url = config.url + '?' + tansParams(config.params);
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }
        if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
            const requestObj = {
                url: config.url,
                data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
                time: new Date().getTime(),
            };
            const sessionObj = cache.session.getJSON('sessionObj');
            if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
                cache.session.setJSON('sessionObj', requestObj);
            } else {
                const s_url = sessionObj.url; // 请求地址
                const s_data = sessionObj.data; // 请求数据
                const s_time = sessionObj.time; // 请求时间
                const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
                if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                    const message = i18n.t('utils.request.469615-0');
                    console.warn(`[${s_url}]: ` + message);
                    return Promise.reject(new Error(message));
                } else {
                    cache.session.setJSON('sessionObj', requestObj);
                }
            }
        }
        return config;
    },
    (error) => {
        console.log(error);
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (res) => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default'];
        // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data;
        }
        if (code === 401) {
            if (!isRelogin.show) {
                // store.dispatch('LogOut').then(() => {
                //     location.href = '/index';
                // });
            }
            console.error(i18n.t('utils.request.469615-5'));
            // return Promise.reject(i18n.t('utils.request.469615-5'));
        } else if (code === 500) {
            console.error(msg);
            // Vue.prototype.$message({ message: msg, type: 'error' });
            return Promise.reject('error');
        } else if (code === 601) {
            console.error(msg);
            // Vue.prototype.$message({ message: msg, type: 'warning' });
            return Promise.reject('error');
        } else if (code !== 200) {
            console.error(msg);
            // Notification.error({ title: msg });
            return Promise.reject('error');
        } else {
            return res.data;
        }
    },
    (error) => {
        console.log('err' + error);
        let { message } = error;
        if (message == 'Network Error') {
            message = i18n.t('utils.request.469615-6');
        } else if (message.includes('timeout')) {
            message = i18n.t('utils.request.469615-7');
        } else if (message.includes('Request failed with status code')) {
            message = i18n.t('utils.request.469615-8') + message.substr(message.length - 3) + i18n.t('utils.request.469615-9');
        }
        console.error(message);
        // Vue.prototype.$message({ message: message, type: 'error', duration: 5 * 1000 });
        return Promise.reject(error);
    }
);

export default service;
